<template>
  <Modal
    v-model="_value"
    width="500"
    title="添加维修订单"
    @on-visible-change="visibleChange"
    ok-text="添加"
    @on-ok="onOk">
    <Form ref="loginForm" :model="maintainOrder" :label-width="80" >
      <FormItem prop="businessUserId" label="问题车辆">
        <Select placeholder="请选择问题车辆"
                v-model="maintainOrder.vehicleInfoId"
                filterable
                remote
                :remote-method="searchVehicleInfo"
                :loading="searchVehicleInfoLoading"
                class="field" style="width: 80%;"
                clearable>
          <Option v-for="(option, index) in searchVehicleInfoList" :value="option.id" :key="option.id">{{option.registrationNum==null?option.vin:option.registrationNum}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="bookingDatetime" label="预约时间">
        <DatePicker type="date" v-model="maintainOrder.bookingDatetime"
                    placeholder="选择日期"></DatePicker>
      </FormItem>
      <FormItem prop="question" label="问题描述">
        <Input class="field" v-model="maintainOrder.question" type="textarea">
        </Input>
      </FormItem>
      <FormItem prop="remark" label="备注">
          <Input class="field" v-model="maintainOrder.remark" type="textarea">
          </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'addmaintainordermodal',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      searchVehicleInfoLoading: false,
      searchVehicleInfoList: [],

      maintainOrder: {
        vehicleInfoId: null,
        bookingDatetime: null,
        question: null,
        remark: null
      }
    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    searchVehicleInfo (input) {
      this.searchVehicleInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleInfoList = []
        this.searchVehicleInfoLoading = false
      } else {
        store.dispatch('VehicleInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleInfoList = store.getters.get_VehicleInfo_SearchByNameResult ? store.getters.get_VehicleInfo_SearchByNameResult : []
          this.searchVehicleInfoLoading = false
        }).catch(err => {
          this.searchVehicleInfoLoading = false
        })
      }
    },
    onOk () {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认添加维修订单</p>',
        onOk: () => {
          store.dispatch('MaintainOrderServ_AddObj', { params: this.maintainOrder }).then(() => {
            this.$Message.success('添加维修订单成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {
        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.maintainOrder.vehicleInfoId = null
        this.maintainOrder.bookingDatetime = null
        this.maintainOrder.question = null
        this.maintainOrder.remark = null
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
